import { render, staticRenderFns } from "./InputColorPicker.vue?vue&type=template&id=24738828&"
import script from "./InputColorPicker.vue?vue&type=script&lang=js&"
export * from "./InputColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports